
import Actions from './actions';
import Form from './form.jsx';
import React from 'react';
import {Helmet} from 'react-helmet';
import Qs from 'qs';

let preselectPlan = "0";

class SignupPageAccountAPI extends React.Component {

  async componentDidMount() {
    await Actions.getUserCreds();
    await Actions.getPlanOptions();
  }

  render() {

    if (this.props){
      const query = Qs.parse(this.props.location.search.substring(1));
      if (query.plan){
        preselectPlan = String(Math.min(Math.max(Number(query.plan), 0), 3));
      }
    }
    return (
      <section className="section-home container">
        <Helmet>
          <title>Sign up</title>
        </Helmet>
        <div className="row">
          <div className="col-12">
            <Form plan_id={preselectPlan}/>
          </div>
        </div>
      </section>
    );
  }
}

export default SignupPageAccountAPI;



// WEBPACK FOOTER //
// ./client/pages/main/signupAccountAPI/index.jsx